export const SUPER_ADMIN = 'SUPER_ADMIN';
export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const SWITCH_TO_USER = 'SWITCH_TO_USER';
